 <template>
  <div>
    <md-dialog
      :md-active.sync="show"
      class="mkt-ops -main-font bookprice-dialog-share-file"
      :md-click-outside-to-close="false"
      @md-closed="dlgClose"
      style="width:50%; left:25% !important; height:72%"
    >
      <div
        style="position: absolute; top: 45%; left: 45%; width: 10%; z-index: 8;"
        v-show="loading == true"
      >
        <md-progress-spinner
          :md-stroke="8"
          :md-diameter="65"
          md-mode="indeterminate"
        ></md-progress-spinner>
      </div>
      <div class="bg-backdrop" v-show="loading == true"></div>

      <md-dialog-title style="padding-left: 35px;" class="font-kanit"
        >การตั้งค่าแชร์</md-dialog-title
      >
      <div class="dialog-content">
        <div class="md-layout">
          <div
            class="md-layout-item md-size-100 font-kanit"
            style="padding-left: 5px; font-size: 14px;"
          >
            ชื่อไฟล์ในการแชร์
          </div>
          <!-- <div
            class="md-layout-item md-size-100"
            style="padding-left: 5px; font-weight: bold; font-size: 14px;"
          >
            <md-field class="custom-input">
              <md-input type="text" v-model="url" readonly></md-input>
            </md-field>
          </div> -->
          <div
            class="md-layout-item md-size-100"
            style="padding-left: 5px; margin-top: 3px;"
          >
            <multiselect
              v-model="selectedShareLink"
              id="title"
              label="title"
              track-by="title"
              :open-direction="'bottom'"
              :options="optionsShareLink"
              :searchable="false"
              :max-height="180"
              :show-no-results="false"
              :select-label="''"
              :deselect-label="''"
              :selected-label="''"
              :hide-selected="false"
              :allow-empty="false"
              @select="setDataShareLink"
              style="margin-left: 0;width: 100%"
            >
              <template slot="singleLabel" slot-scope="{ option }">
                <div>
                  <div style="font-family: kanit; padding-top: 3px;">
                    {{ option.title }}
                  </div>
                </div>
              </template>
            </multiselect>
          </div>

          <div
            class="md-layout-item md-size-100 font-kanit"
            style="padding-left: 5px; font-size: 14px; margin-top: 5px;"
          >
            ลิงค์ในการแชร์
          </div>
          <div
            class="md-layout-item md-size-100 font-kanit"
            style="font-size: 13px; margin: 5px 0;"
            :title="urlFile"
          >
            <div
              class="md-layout-item md-size-100"
              style="padding-left: 5px; font-weight: bold; font-size: 14px;"
            >
              <md-field class="custom-input">
                <md-input type="text" v-model="urlFile" readonly></md-input>
              </md-field>
            </div>
          </div>
          <!-- <div class="md-layout-item md-size-100" style="height: 20px"></div> -->
          <div
            class="md-layout-item md-size-100 font-kanit"
            style="padding-left: 5px; font-size: 14px; margin-top: 10px; margin-bottom: 12px;"
          >
            ผู้มีสิทธิ์เข้าถึง
          </div>

          <!-- TABLE -->
          <div
            class="md-layout-item md-size-100 table-share-file"
            style="width: 95%;"
          >
            <!-- HEAD -->
            <!-- <div class="divHeadList">
              <div style="width: 60%;" class="-font-kanit">ชื่อ</div>
              <div style="width: 60%;" class="-font-kanit"></div>
              <div style="width: 35%;" class="-font-kanit">แก้ไขล่าสุด</div>
              <div style="width: 35%;" class="-font-kanit"></div>
              <div style="width: 5%;"></div>
            </div> -->

            <!-- BODY -->
            <div class="divBodyList">
              <div
                v-show="seleteUser.length === 0"
                :class="'row-bg-gray'"
                style="display: block; text-align: center; font-size: 14px;"
              >
                No data in table.
              </div>

              <div
                v-for="(file, fileIndex) in seleteUser"
                :key="fileIndex"
                :class="'row-bg-gray'"
              >
                <div style="width: 95%;">
                  <i
                    class="md-icon material-icons"
                    style="font-size: 20px !important;"
                    >person</i
                  >
                  {{ file.label }}
                  <div v-show="file.shared === true" style="display:inline-block; color:#3f51b5; float:right">
                    Share to
                  </div>
                </div>
                <div style="width: 5%;">
                  <i
                    v-show="file.approve !== true"
                    title="Remove"
                    class="md-icon material-icons -delete"
                    style="color: #b3b3b3;"
                    v-on:click="deleteUser(fileIndex)"
                    >clear</i
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <md-dialog-actions style="padding: 10px 17px 15px;">
        <div class="md-layout" style="width:100%; padding-left:2%">
          <div
            class="md-layout-item md-size-100 font-kanit"
            style="padding-left: 5px; font-size: 14px;"
          >
            เชิญคนอื่น
          </div>
          <div
            class="md-layout-item md-size-100 font-kanit"
            style="font-size: 14px; margin-bottom: 5px;"
          >
            <multiselect
              v-model="seleteUser"
              :options="searchUser"
              :multiple="true"
              placeholder=""
              label="label"
              track-by="id"
              :select-label="''"
              :deselect-label="''"
              :selected-label="''"
              :hide-selected="true"
              :max-height="240"
            >
              <template slot="selection" slot-scope="{ values, search, isOpen }"
                >ป้อนชื่อหรือ email</template
              >
            </multiselect>
            <!--<pre class="language-json"><code>{{ shareUser  }}</code></pre>-->
            <!--            <multiselect
              v-model="selectedProductType"
              id="type"
              label="title"
              track-by="code"
              placeholder="Search Type"
              :open-direction="'bottom'"
              :options="optionsProductType"
              :searchable="true"
              :max-height="180"
              :show-no-results="false"
              :custom-label="customLabelProduct"
              :select-label="''"
              :deselect-label="''"
              :selected-label="''"
              :hide-selected="true"
              @select="setDataProduct"
            >
              <template slot="singleLabel" slot-scope="{ option }">
                <div>
                  <div>{{ option.code }} - {{ option.title }}</div>
                  <div
                    class="-delete"
                    @mousedown.prevent.stop="clearAll(option, 'type')"
                  >
                    <i class="material-icons">close</i>
                  </div>
                </div>
              </template>
            </multiselect>-->
          </div>
          <div class="md-layout-item md-size-75"></div>
          <div class="md-layout-item md-size-25">
            <md-button class="-cancel" @click="onClickCancel()"
              >CANCEL</md-button
            >
            <!-- <md-button class="-confirm" @click="onSendShare()">SEND</md-button> -->
            <md-button class="-confirm" @click="onClickConfirm()"
              >SEND</md-button
            >
          </div>
        </div>
      </md-dialog-actions>
    </md-dialog>

    <dialog-confirm
      :show="showDialogConfirm"
      :title="titleDialog"
      :content="contentDialog"
      :confirmText="confirmText"
      :cancelText="cancelText"
      @cancel="onCancel()"
      @confirm="onConfirm()"
    ></dialog-confirm>

    <md-snackbar
      :md-position="position"
      :md-duration="isInfinity ? Infinity : duration"
      :md-active.sync="showSnackbar"
      md-persistent
    >
      <span>{{ contentSnackbar }}</span>
      <md-button class="md-primary" @click="showSnackbar = false">OK</md-button>
    </md-snackbar>
  </div>
</template>

<script>
import DialogConfirm from "./../../shared/dialog-confirm";
import BookpriceService from "@/services/bookprice";
import moment from "moment-timezone";

export default {
  name: "dialog-import-file",
  components: {
    DialogConfirm
  },
  //    mounted(){
  //        console.info('mounted');
  //        console.info('this.tableShareUser', this.tableShareUser);
  //        this.seleteUser = this.tableShareUser;
  //    },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    // url: {
    //   type: String
    // },
    dataShareFile: {
      type: Array
    },
    // tableShareUser: {
    //   type: Array
    // },
    searchUser: {
      type: Array
    }

    //    data: {
    //      type: Array,
    //      required: true
    //    }
  },
  watch: {
    // tableShareUser() {
    //   this.seleteUser = this.tableShareUser;
    // }
    show() {
      if (this.show) {
        // console.log("this.dataShareFile ==>", this.dataShareFile);
        this.seleteUser = [];
        let labelName = "";
        let labelLastName = "";
        let rsDatas = [];
        let rs = {};
        this.optionsShareLink = [];
        this.dataShareFile.forEach(element => {
          rsDatas = [];
          element.user.forEach(elUser => {
            let elLabel = elUser.label.split(" ");
            labelName =
              elLabel[0].substring(0, 1).toUpperCase() +
              elLabel[0].substring(1).toLowerCase();
            labelLastName =
              elLabel[1].substring(0, 1).toUpperCase() +
              elLabel[1].substring(1).toLowerCase();
            rs = elUser;
            rs["label"] = labelName + " " + labelLastName;
            rsDatas.push(rs);
            element.user = rsDatas;
          });

          this.optionsShareLink.push({ title: element.title });
          this.tableImportFile = this.data;
        });

        this.selectedShareLink.title = this.dataShareFile[0].title;
        this.seleteUser = this.dataShareFile[0].user;
        this.urlFile = this.dataShareFile[0].url;

        this.tmpDataShareFile = JSON.parse(JSON.stringify(this.dataShareFile));
      }
    }
  },
  data() {
    return {
      seleteUser: [],
      checkEvent: "",
      showDialogConfirm: false,
      titleDialog: "",
      contentDialog: "",
      confirmText: "OK",
      cancelText: "CANCEL",
      tableImportFile: [],
      shareUser: [],
      fileID: "",
      fileIdDelete: "",
      fileNameDelete: "",
      showSnackbar: false,
      position: "center",
      duration: 20000,
      isInfinity: false,
      contentSnackbar: "",
      loading: false,
      selectedShareLink: {},
      optionsShareLink: [],
      urlFile: "",
      tmpDataShareFile: []
    };
  },
  methods: {
    setDataShareLink(selectedOption) {
      // console.log("this.tmpDataShareFile ==>", this.tmpDataShareFile);
      let datas = this.tmpDataShareFile.filter(item => {
        return selectedOption.title === item.title;
      });
      // console.log("datas ==>", datas);
      this.seleteUser = datas[0].user;
      this.urlFile = datas[0].url;
      // console.log("this.seleteUser ==>", this.seleteUser);
    },
    dlgClose() {
      this.show = false;
    },
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
    selectFile(id) {
      this.fileID = id;
    },
    deleteFile(files) {
      this.checkEvent = "delete";
      this.fileIdDelete = files.id;
      this.fileNameDelete = files.name;
      this.titleDialog = "Delete File";
      this.contentDialog =
        "Are you sure you want to delete " + this.fileNameDelete + " ?";
      this.cancelText = "NO";
      this.confirmText = "YES";
      this.showDialogConfirm = true;
    },
    deleteUser(index) {
      this.seleteUser.splice(index, 1);
      //            delete this.seleteUser[index];
      //            this.checkEvent = "delete";
      //            this.fileIdDelete = files.id;
      //            this.fileNameDelete = files.name;
      //            this.titleDialog = "Delete File";
      //            this.contentDialog =
      //                "Are you sure you want to delete " + this.fileNameDelete + " ?";
      //            this.cancelText = "NO";
      //            this.confirmText = "YES";
      //            this.showDialogConfirm = true;
    },
    fileDelete() {
      this.checkBackdrop = false;
      this.loading = true;
      BookpriceService.deleteFilePriceList(this.fileIdDelete).then(response => {
        this.loading = false;
        if (!response.status) {
          this.contentSnackbar = "Delete file unsuccessfully. " + response.msg;
          this.showSnackbar = true;
        } else {
          let index = this.tableImportFile
            .map(function(e) {
              return e.id;
            })
            .indexOf(this.fileIdDelete);
          if (index > -1) {
            this.tableImportFile.splice(index, 1);
          }

          this.contentSnackbar =
            "Delete file '" + this.fileNameDelete + "' successfully.";
          this.showSnackbar = true;
        }
      });
    },
    onClickCancel() {
      this.checkEvent = "cancel";
      this.titleDialog = "";
      this.cancelText = "CANCEL";
      this.confirmText = "OK";
      this.contentDialog = "Are you sure you want to add and close ?";
      this.showDialogConfirm = true;
    },
    onClickConfirm() {
      this.checkEvent = "confirm";
      this.titleDialog = "";
      this.cancelText = "CANCEL";
      this.confirmText = "OK";
      this.contentDialog = "Are you sure you want to confirm ?";
      this.showDialogConfirm = true;
    },
    onCancel() {
      this.showDialogConfirm = false;
    },
    onConfirm() {
      if (this.checkEvent === "cancel") {
        this.$emit("cancel");
      } else if (this.checkEvent === "confirm") {
        this.loading = true;
        let emails = [];
        for (let i = 0; i < this.seleteUser.length; i++) {
          emails.push(this.seleteUser[i].id);
        }
        BookpriceService.sendShareTemplate({
          file_url: this.urlFile,
          email: emails
        }).then(response => {
          this.loading = false;
          if (response.status) {
            this.contentSnackbar = "Share file complete.";
            this.showSnackbar = true;
            this.$emit("confirm");
          } else {
            this.contentSnackbar = "Share file not complete.";
            this.showSnackbar = true;
            return;
          }
        });
      }
      this.showDialogConfirm = false;
    }
    // onSendShare() {
    //   let emails = [];
    //   for (let i = 0; i < this.seleteUser.length; i++) {
    //     emails.push(this.seleteUser[i].id);
    //   }
    //   BookpriceService.sendShareTemplate({
    //     file_url: this.url,
    //     email: emails
    //   }).then(response => {
    //     this.showShareDialog = false;
    //   });
    // }
  }
};
</script>

<style lang="scss">
.bookprice-dialog-share-file {
  width: 70%;
  height: 80% !important;
  transform: unset !important;
  top: 9% !important;
  left: 17% !important;
  font-weight: 400 !important;

  .font-kanit {
    font-family: kanit !important;
  }

  .table-share-file {
    padding: 0;

    .divBodyList {
      height: calc(80vmin - 435px);

      .row-bg-gray:hover {
        &.-file {
          cursor: pointer;
        }
      }

      .row-bg-blue {
        border-radius: 4px;
        background: #e8f0fe;
        color: #005fd0;

        .-delete {
          color: #005fd0 !important;
        }
      }
    }
  }

  .multiselect {
    width: 98%;

    .z-index-top {
      z-index: 10;
    }

    margin: 10px 5px 10px 2px;
    .multiselect__single,
    .multiselect__input {
      font-size: 14px;

      div {
        display: flex;
        width: 100%;
        .-delete {
          width: 5%;

          .material-icons {
            font-size: 18px;
            margin-top: 1px;
            cursor: pointer;
            color: gray;
          }
        }
      }
    }

    .multiselect__tags {
      padding: 8px 30px 0 8px;

      ::placeholder {
        color: #bdbdbd;
        opacity: 1;
      }
    }

    .multiselect__content-wrapper {
      font-size: 14px;
      z-index: 10;
    }

    .multiselect__option {
      min-height: 34px;
      padding: 12px 12px 0px 12px;
    }

    ::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }
  }

  .bg-backdrop {
    &.-sparse {
      background: rgba(0, 0, 0, 0.28) !important;
    }
    background: rgba(0, 0, 0, 0.6);
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 7;
    top: 0;
    left: 0;
  }
}
</style>